import type { UserData } from '../reducers/user';
import type { CartState } from '../reducers/cart';
import {
  SIGN_IN,
  SIGN_UP,
  SIGN_OUT,
  REQ_DATA,
  SIGN_UP_UPDATE,
  ORDERS_REPORT_DATA,
  SIGN_IN_UPDATE,
  DEPT_DATA,
  BLOCK_DATA,
  PRODUCTS_DATA,
  ORDERS_DATA,
  CLEAR_CART_DATA,
  ADD_CART_DATA,
  UPDATE_CART_DATA,
  REMOVE_CART_DATA,
  RESTAURANTS_DATA,
  LOG_ERROR,
  CLEAR_ERROR,
  ROOM_BILLS,
  SELECTED_RESTAURANT_DATA,
  SYNC_CART_DATA,
  GLOBAL_CONFIG,
  PUBLIC_RESTAURANTS_DATA,
} from '@constants/actionTypes';

export const signInAuth = (user: UserData): { type: string; payload: UserData } => ({
  type: SIGN_IN,
  payload: user,
});
export const signInUpdateAuth = (user: UserData): { type: string; payload: UserData } => ({
  type: SIGN_IN_UPDATE,
  payload: user,
});
export const signUpAuth = (user: UserData): { type: string; payload: UserData } => ({
  type: SIGN_UP,
  payload: user,
});
export const signUpUpdateAuth = (
  formData: UserData
): { type: string; payload: UserData } => ({
  type: SIGN_UP_UPDATE,
  payload: formData,
});
export const signOutAuth = (_user?: unknown): { type: string; payload?: unknown } => ({
  type: SIGN_OUT,
  payload: _user,
});
export const updateReqData = (
  requests: unknown[]
): { type: string; payload: unknown[] } => ({
  type: REQ_DATA,
  payload: requests,
});
export const updateDepartments = (
  requests: unknown
): { type: string; payload: unknown } => ({
  type: DEPT_DATA,
  payload: requests,
});
export const updateBlocks = (
  requests: unknown
): { type: string; payload: unknown } => ({
  type: BLOCK_DATA,
  payload: requests,
});
export const addToCartData = (
  requests: Record<string, unknown>,
  tableNumber: string | undefined,
  resId: string | undefined
): { type: string; payload: Record<string, unknown>; tableNumber?: string; resId?: string } => ({
  type: ADD_CART_DATA,
  payload: requests,
  tableNumber,
  resId,
});
export const updateToCartData = (
  requests: Record<string, unknown>,
  tableNumber: string | undefined,
  resId: string | undefined
): { type: string; payload: Record<string, unknown>; tableNumber?: string; resId?: string } => ({
  type: UPDATE_CART_DATA,
  payload: requests,
  tableNumber,
  resId,
});
export const removeToCartData = (
  _requests: unknown,
  tableNumber: string | undefined,
  resId: string | undefined
): { type: string; tableNumber?: string; resId?: string } => ({
  type: REMOVE_CART_DATA,
  tableNumber,
  resId,
});
export const clearCartData = (
  resId?: string
): { type: string; payload: Record<string, unknown>; resId?: string } => ({
  type: CLEAR_CART_DATA,
  payload: {},
  resId,
});
export const syncCartData = (
  cartData: CartState,
  _restaurantId?: string
): { type: string; payload: CartState } => ({
  type: SYNC_CART_DATA,
  payload: cartData,
});
export const updateProducts = (
  requests: unknown
): { type: string; payload: unknown } => ({
  type: PRODUCTS_DATA,
  payload: requests,
});
export const updateRestaurants = (
  requests: unknown
): { type: string; payload: unknown } => ({
  type: RESTAURANTS_DATA,
  payload: requests,
});
export const updatePublicRestaurants = (
  requests: unknown
): { type: string; payload: unknown } => ({
  type: PUBLIC_RESTAURANTS_DATA,
  payload: requests,
});
export const updateSelectedRestaurant = (
  requests: unknown
): { type: string; payload: unknown } => ({
  type: SELECTED_RESTAURANT_DATA,
  payload: requests,
});
export const updateOrdersList = (
  requests: unknown
): { type: string; payload: unknown } => ({
  type: ORDERS_DATA,
  payload: requests,
});
export const updateOrdersReport = (
  requests: unknown
): { type: string; payload: unknown } => ({
  type: ORDERS_REPORT_DATA,
  payload: requests,
});
export const logError = (requests: unknown): { type: string; payload: unknown } => ({
  type: LOG_ERROR,
  payload: requests,
});
export const clearError = (_requests?: unknown): { type: string; payload?: unknown } => ({
  type: CLEAR_ERROR,
  payload: _requests,
});
export const updatedRoomBills = (
  requests: unknown
): { type: string; payload: unknown } => ({
  type: ROOM_BILLS,
  payload: requests,
});
export const updateGlobalConfig = (
  requests: unknown
): { type: string; payload: unknown } => ({
  type: GLOBAL_CONFIG,
  payload: requests,
});
